"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPress = exports.KeyCode = void 0;
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["UPARROW"] = 38] = "UPARROW";
    KeyCode[KeyCode["DOWNARROW"] = 40] = "DOWNARROW";
    KeyCode[KeyCode["LEFTARROW"] = 37] = "LEFTARROW";
    KeyCode[KeyCode["RIGHTARROW"] = 39] = "RIGHTARROW";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["ESC"] = 27] = "ESC";
    KeyCode[KeyCode["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
var KeyPress = /** @class */ (function () {
    function KeyPress() {
    }
    KeyPress.shiftIsPressed = function (e) {
        return e.shiftKey;
    };
    KeyPress.altIsPressed = function (e) {
        return e.altKey;
    };
    KeyPress.enterIsPressed = function (e) {
        return e.keyCode === KeyCode.ENTER;
    };
    KeyPress.upArrowIsPressed = function (e) {
        return e.keyCode === KeyCode.UPARROW;
    };
    KeyPress.downArrowIsPressed = function (e) {
        return e.keyCode === KeyCode.DOWNARROW;
    };
    KeyPress.leftArrowIsPressed = function (e) {
        return e.keyCode === KeyCode.LEFTARROW;
    };
    KeyPress.rightArrowIsPressed = function (e) {
        return e.keyCode === KeyCode.RIGHTARROW;
    };
    KeyPress.tabIsPressed = function (e) {
        return e.keyCode === KeyCode.TAB;
    };
    KeyPress.escIsPressed = function (e) {
        return e.keyCode === KeyCode.ESC;
    };
    KeyPress.forwardSlashIsPressed = function (e) {
        return e.keyCode === KeyCode.FORWARDSLASH;
    };
    KeyPress.backspaceIsPressed = function (e) {
        // return e.keyCode === KeyCode.ESC;
        return e.keyCode === KeyCode.BACKSPACE;
    };
    KeyPress.deleteIsPressed = function (e) {
        // return e.keyCode === KeyCode.FORWARDSLASH;
        return e.keyCode === KeyCode.DELETE;
    };
    return KeyPress;
}());
exports.KeyPress = KeyPress;
//# sourceMappingURL=key-press.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/utils/key-press.js
// module id = 124
// module chunks = 8